// Critério local da sessão do portal. Não verifica assinatura ou revogação remota.
export function tokenExpiresAt(token: string): number {
    if (!token) return 0;
    if (token.split('.').length !== 3) return Infinity; // token opaco sem expiração legível
    try {
        const value = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return typeof value.exp === 'number' && Number.isFinite(value.exp) ? value.exp * 1000 : 0;
    } catch { return 0; }
}
